import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Link, SideNav } from 'bonfire-kindling';

import { ResponsiveSideNavContainer } from 'components';

const SettingsSideNav = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <ResponsiveSideNavContainer>
      <ResponsiveSideNavContainer.Content>
        <SideNav
          sx={{
            boxShadow: 'none',
            flexGrow: 1,
            pt: theme => ({ xs: 0, sm: theme.spacing(5) }),
          }}
        >
          <SideNav.Item
            label={t('settings.account.title')}
            to={'/settings/account'}
            component={RouterLink}
            active={pathname === '/settings/account'}
          />
          <SideNav.Item
            label={t('settings.subscription.title')}
            to={'/settings/subscription'}
            component={RouterLink}
            active={pathname === '/settings/subscription'}
          />
          <SideNav.Item
            label={t('settings.business.title')}
            to={'/settings/business'}
            component={RouterLink}
            active={pathname === '/settings/business'}
          />
          <SideNav.Item
            label={t('settings.commodity_codes.title')}
            to={'/settings/commodity-codes'}
            component={RouterLink}
            active={pathname === '/settings/commodity-codes'}
          />
          <SideNav.Item
            label={t('settings.keywords.title')}
            to={'/settings/keywords'}
            component={RouterLink}
            active={pathname === '/settings/keywords'}
          />
          <SideNav.Item
            label={t('settings.location.title')}
            to={'/settings/location'}
            component={RouterLink}
            active={pathname === '/settings/location'}
          />
        </SideNav>
        <Box sx={{ display: 'flex', px: theme => theme.spacing(3), pb: theme => theme.spacing(5) }}>
          <Link
            href="https://gobonfire.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('settings.privacy')}
          </Link>
          <span>&nbsp;|&nbsp;</span>
          <Link
            href="https://gobonfire.com/terms-service/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('settings.terms')}
          </Link>
        </Box>
      </ResponsiveSideNavContainer.Content>
    </ResponsiveSideNavContainer>
  );
};

export default SettingsSideNav;
